import { PaymentKey } from "pages/Payment";
import { useState, useCallback } from "react";

const useUploadPresignLink = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [{ errors: presignError }, setPresignState] = useState<{
    isLoading?: boolean;
    isError?: boolean;
    errors?: any;
    data?: any;
  }>({});

  const onUploadPresignLink = useCallback(
    async (
      presignLink: string,
      binaryData: any,
      contentType: string,
      key: PaymentKey
    ) => {
      setIsLoading(true);
      setPresignState({});
      try {
        const state = {
          isLoading: true,
          isError: false,
          data: undefined,
          errors: undefined,
        };

        if (key === PaymentKey.UPLOAD_DISBURSEMENT_REPORT)
          setPresignState(state);

        await fetch(presignLink, {
          method: "PUT",
          body: binaryData,
          headers: {
            "Content-Type": contentType,
            "x-amz-acl": "bucket-owner-full-control",
          },
        });

        return true;
      } catch (err: any) {
        setIsLoading(false);
        const state = {
          isLoading: false,
          isError: true,
          errors: {
            data: { errors: [{ message: err.message }] },
          },
          data: undefined,
        };

        if (key === PaymentKey.UPLOAD_DISBURSEMENT_REPORT) {
          setPresignState(state);
        }

        return false;
      }
    },
    []
  );

  return {
    onUploadPresignLink,
    isLoading,
    presignError,
    setPresignState,
    setIsLoading,
  };
};

export default useUploadPresignLink;
